module.exports = __webpack_public_path__ + "img/avocadolachskugelartshot.3fa093d1.jpg";